import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialsModule } from '../../modules/material.module';
import { QuickViewComponent } from './quick-view.component';

@NgModule({
  declarations: [QuickViewComponent],
  imports: [CommonModule, MaterialsModule],
  exports: [QuickViewComponent],
})
export class QuickViewModule {}
